import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { FabricUserDataFunctionsLinkedService } from 'app/model/linkedservice/fabric-userdatafunctions.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricUserDataFunctionsLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class FabricUserDataFunctionsLinkedServiceAdapter extends LinkedServiceAdapter<FabricUserDataFunctionsLinkedService> {

    protected modelConstructor(): new () => FabricUserDataFunctionsLinkedService {
        return FabricUserDataFunctionsLinkedService;
    }

    protected model(): IModel {
        return FabricUserDataFunctionsLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: FabricUserDataFunctionsLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: FabricUserDataFunctionsLinkedService): Promise<FabricUserDataFunctionsLinkedService> {
        return linkedService;
    }
}
